import { render, staticRenderFns } from "./UserRemoteWaterList.vue?vue&type=template&id=b023b9be&scoped=true"
import script from "./UserRemoteWaterList.vue?vue&type=script&lang=js"
export * from "./UserRemoteWaterList.vue?vue&type=script&lang=js"
import style0 from "./UserRemoteWaterList.vue?vue&type=style&index=0&id=b023b9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b023b9be",
  null
  
)

export default component.exports